/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
.m-meta-header {
  display: flex;
  flex-direction: column-reverse;
  flex-wrap: wrap-reverse;
  row-gap: 0.625rem;
  column-gap: 1.3125rem;
  width: -moz-fit-content;
  width: fit-content;
  padding-bottom: 0.625rem;
  overflow: hidden;
}
.m-meta-header__item-group {
  display: flex;
  flex-wrap: wrap;
  column-gap: 1.3125rem;
}
.m-meta-header__item {
  display: grid;
  grid-template-columns: 0 auto 1fr;
  row-gap: 0.3125rem;
  text-wrap: balance;
  margin-bottom: 0;
  font-size: 1.125em;
  font-weight: 500;
  letter-spacing: inherit;
  line-height: 1.25;
  text-transform: inherit;
}
p + .m-meta-header__item, ul + .m-meta-header__item, ol + .m-meta-header__item, dl + .m-meta-header__item, figure + .m-meta-header__item, img + .m-meta-header__item, table + .m-meta-header__item, blockquote + .m-meta-header__item, h1 + .m-meta-header__item, .h1 + .m-meta-header__item, h2 + .m-meta-header__item, .h2 + .m-meta-header__item, h3 + .m-meta-header__item, .h3 + .m-meta-header__item, h5 + .m-meta-header__item, .h5 + .m-meta-header__item, h6 + .m-meta-header__item, .h6 + .m-meta-header__item {
  margin-top: 1.6666666667em;
}
@media only all and (max-width: 37.5em) {
  .m-meta-header__item {
    margin-bottom: 0.625em;
    font-size: 1em;
    line-height: 1.125;
  }
}
@media only all and (max-width: 37.5em) {
  .m-meta-header__item {
    margin-bottom: 0.3125rem;
  }
}
.m-meta-header__item .cf-icon-svg {
  margin-right: 0.3125rem;
}
.m-meta-header__item::before {
  content: "|";
  margin-left: -0.8125rem;
}
.m-meta-header__item .a-date {
  font-size: 0.875rem;
  line-height: 1.7142857143;
  margin-bottom: 0;
}
@media only all and (min-width: 37.5625em) {
  .m-meta-header {
    flex-direction: row;
  }
}